<template>
<!--  <v-fade-transition>-->
    <v-container fill-height fluid pa-0
                 style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
                 v-if="show"
    >
      <v-row class="fill-height white--text" no-gutters>
        <v-col class="align-self-start" cols="12">
          <top-bar>
            <template v-slot:logos>
              <v-row class="fill-height flex-nowrap pt-6 pl-6" no-gutters>
                <v-col class="flex-shrink-1 pr-4" cols="auto">
                  <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
                </v-col>
                <v-col class="flex-shrink-1 " cols="auto">
                  <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>
                </v-col>
              </v-row>
            </template>
            <template v-slot:title>VP for a Day</template>
            <template v-slot:info>
              <v-row class="pt-8 pr-8" justify="end" no-gutters>
                <v-btn dark icon x-large @click="$router.replace(`/${$route.params.app}/menu`)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-row>
            </template>
          </top-bar>
          <v-row align="center" class="px-12" dense justify="center" style="margin-bottom: 70px;">
            <v-col lg="6" md="6" sm="12" xl="4" cols="12">
              <highcharts v-if="isRtl"
                          :options="require('@/assets/charts/required_invesment_in_gcc_arabic.json')"
              ></highcharts>
              <highcharts v-else
                          :options="require('@/assets/charts/required_invesment_in_gcc.json')"
              ></highcharts>
            </v-col>
            <v-col lg="6" md="6" sm="12" xl="4" cols="12">
              <highcharts v-if="isRtl"
                          :options="require('@/assets/charts/impact_of_emerging_technologies_pie_arabic.json')"
              ></highcharts>
              <highcharts v-else
                          :options="require('@/assets/charts/impact_of_emerging_technologies_pie.json')"
              ></highcharts>
            </v-col>
            <v-col lg="6" md="6" sm="12" xl="4" cols="12">
              <v-simple-table v-if="!!tableData"
                              class="white--text"
                              style="background-color: transparent;"
              >
                <thead>
                <tr>
                  <td v-if="isRtl"
                      colspan="2"
                      class="font-weight-bold"
                      style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                      dir="rtl"
                  >{{ tableData.rtl_title }}
                  </td>
                  <td v-else
                      class="font-weight-bold"
                      colspan="2"
                      style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                  >{{ tableData.title }}
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, rowIndex) in isRtl ? tableData.rtl_data : tableData.data" :key="rowIndex">
                  <td v-for="(col, colIndex) in row"
                      :dir="isRtl ? 'rtl' : 'ltr'"
                      :key="colIndex"
                      :class="colIndex === 0 ? 'font-weight-bold' : ''"
                      :style="{ 'border-bottom-left-radius': rowIndex === tableData.data.length-1 && colIndex === 0 ? '10px' : '',
                              'border-bottom-right-radius': rowIndex === tableData.data.length-1 && colIndex === row.length-1 ? '10px' : '',
                              'white-space': colIndex === 0 ? 'nowrap' : ''}"
                  >{{ col }}
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col lg="6" md="6" sm="12" xl="4" cols="12">
              <highcharts v-if="isRtl"
                          :options="require('@/assets/charts/adaptation_of_nextgen_arabic.json')"
              ></highcharts>
              <highcharts v-else
                          :options="require('@/assets/charts/adaptation_of_nextgen.json')"
              ></highcharts>
            </v-col>
            <v-col lg="6" md="6" sm="12" xl="4" cols="12">
              <v-row v-if="!!infographicTwo" align="start" class="fill-height" justify="center" no-gutters>
                <v-col cols="12">
                  <top-growth-strategies v-if="isRtl" rtl></top-growth-strategies>
                  <top-growth-strategies v-else></top-growth-strategies>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="white--text"
           style="position: fixed; bottom: 0; height: 60px; width: 100%; background-color: #1D4162;">
        <stocks-ticker :stock-data="stockData"></stocks-ticker>
      </div>
    </v-container>
<!--  </v-fade-transition>-->
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import StocksTicker from "@/components/CeoForADay/StocksTicker";
import stockData from '@/assets/text/stock_data.json';
import questions from '@/assets/text/ceo_for_a_day_questions.json'
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import DataModule from 'highcharts/modules/data';
import TopGrowthStrategies from "@/views/Tools/Sec/Components/TopGrowthStrategies";

DataModule(Highcharts);

export default {
  name: "CeoForADay",
  components: {
    TopBar,
    StocksTicker,
    highcharts: Chart,
    TopGrowthStrategies,
  },
  computed: {
    isRtl() {
      return false;
    },
  },
  data: () => ({
    tableData: null,
    infographicOne: null,
    infographicTwo: null,
    stockData: null,
    questions: [],
    show: true,
  }),
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    translate() {
      this.show = false;

      if (this.$store.state.rtl) {
        this.$store.dispatch('setRtlFalse');
      } else {
        this.$store.dispatch('setRtlTrue');
      }

      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  mounted() {
    this.tableData = require('@/assets/tables/international_labour_organization.json');
    this.infographicOne = require('@/assets/infographics/pwc_global_survey.json');
    this.infographicTwo = require('@/assets/infographics/global_internet.json');
    this.stockData = stockData;
    this.questions = questions;
  }
}
</script>

<style scoped>
tbody tr:hover {
  background-color: transparent !important;
}

table, th, td {
  border: 1px solid white;
}
</style>